import React, { Fragment, useReducer } from "react";
import { Modal, Tab, Nav } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import UserDetailProfileSection from "./component/UserDetailProfileSection";
import UserDetailTransactionSection from "./component/UserDetailTransactionSection";
import { BgCard } from "../../elements/CardDesign";
import { FaArrowLeft } from "react-icons/fa";

const ProgressBar = [
  { title: "Photoshop", percent: "70%", color: "danger" },
  { title: "Code Editor", percent: "85%", color: "info", space: "mt-4" },
  { title: "Illustrator", percent: "65%", color: "success", space: "mt-4" },
];

const detailblog = [
  { title: "Gender", subtitle: "Male" },
  { title: "Education", subtitle: "PHD" },
  { title: "Designation", subtitle: "Sr. Professor" },
  { title: "Operation Done", subtitle: "120" },
];

const socialDetail = [
  {
    name: "Followers",
    number: "1204",
    title: "Projects",
    task: "150",
    border: "border-end",
  },
  {
    name: "Following",
    number: "2540",
    title: "Uploads",
    task: "140",
    border: "border-end",
  },
  { name: "Friends", number: "2540", title: "Tasks", task: "45" },
];

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case "sendMessage":
      return { ...state, sendMessage: !state.sendMessage };
    case "postModal":
      return { ...state, post: !state.post };
    case "linkModal":
      return { ...state, link: !state.link };
    case "cameraModal":
      return { ...state, camera: !state.camera };
    case "replyModal":
      return { ...state, reply: !state.reply };
    default:
      return state;
  }
};

const bgCarddBlog = [
  {title:"Total Shares", number:'3180', icon: <i className="la la-users" />, percent:'80%', color:"primary"},
  {title:"Total Value of shares", number:'360', icon:<i className="la la-user" />, percent:'50%', color:"warning"},
];

const personalDetail = [
  { title: "Name", subtitle: "Mitchell C.Shay" },
  { title: "Email", subtitle: "info@example.com" },
  { title: "Availability", subtitle: "Full Time (Free Lancer)" },
  { title: "Age", subtitle: "27" },
  { title: "Location", subtitle: "Rosemont Avenue Melbourne, Florida" },
  { title: "Year Experience", subtitle: "07 Year Experiences" },
];

function UserProfile({userD}) {
  //  console.log("userD",userD)
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <button
                    type="submit"
                    className="btn text-primary mt-3 px-0"
                    onClick={()=>navigate(-1)}>
                     <FaArrowLeft /> Go back
                  </button>
                  <div className="profile-tab">
                   <UserDetailProfileSection userD={userD}/>
                    {/* <div className="custom-tab-1">
                      <Tab.Container defaultActiveKey={"Profile"}>
                        <Nav as="ul" className="nav nav-tabs">
                          <Nav.Item as="li">
                            <Nav.Link eventKey="Profile">Profile</Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li">
                            <Nav.Link eventKey="Transaction">Transactions</Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content className="tab-content">
                          <Tab.Pane eventKey={"Transaction"}>
                          <div className="row mt-4">  
                          {bgCarddBlog.map((item, index)=>(
                            <div className="col-md-3">
		                     		<div className={`widget-stat card bg-${item.color}`}>
		                     			<div className="card-body">								
		                     				<BgCard title={item.title} number={item.number} percent={item.percent} color={item.color} icon={item.icon}/>
		                     			</div>
		                     		</div>
                             </div>		
		                     ))}
                         </div>
                            <UserDetailTransactionSection/>
                          </Tab.Pane>

                          <Tab.Pane eventKey={"Profile"}>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Model ------ */}
      {/* Camera Model */}
      <Modal
        show={state.camera}
        onHide={() => dispatch({ type: "cameraModal" })}
        centered>
        <div className="modal-header">
          <h5 className="modal-title">Upload images</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "cameraModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <div className="input-group mb-3">
            <span className="input-group-text">Upload</span>
            <div className="form-file">
              <input
                type="file"
                className="form-file-input form-control  border-s-1"
              />
            </div>
          </div>
        </div>
      </Modal>
      {/* Social Modal */}
      <Modal
        className="post-input"
        show={state.link}
        onHide={() => dispatch({ type: "linkModal" })}
        centered>
        <div className="modal-header">
          <h5 className="modal-title">Social Links</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "linkModal" })}>              
          </button>
        </div>
        <div className="modal-body">
          <Link to={"#"} className="btn-social me-1 facebook mb-1">
            <i className="fab fa-facebook-f" />
          </Link>
          <Link to={"#"} className="btn-social me-1 google-plus mb-1">
            <i className="fab fa-google-plus-g" />
          </Link>
          <Link to={"#"} className="btn-social me-1 linkedin mb-1">
            <i className="fab fa-linkedin" />
          </Link>
          <Link to={"#"} className="btn-social me-1 instagram mb-1">
            <i className="fab fa-instagram" />
          </Link>
          <Link to={"#"} className="btn-social me-1 twitter mb-1">
            <i className="fab fa-twitter" />
          </Link>
          <Link to={"#"} className="btn-social me-1 youtube mb-1">
            <i className="fab fa-youtube" />
          </Link>
          <Link to={"#"} className="btn-social whatsapp mb-1">
            <i className="fab fa-whatsapp" />
          </Link>
        </div>
      </Modal>

      {/* Post Modal */}
      <Modal
        className="post-input"
        show={state.post}
        onHide={() => dispatch({ type: "postModal" })}
        centered>
        <div className="modal-header">
          <h5 className="modal-title">Post</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "postModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <textarea
            name="textarea"
            id="textarea2"
            cols="30"
            rows="3"
            className="form-control bg-transparent"
            defaultValue={"Please type what you want...."}
          />
          <Link to={"#"} className="btn btn-primary">
            Post
          </Link>
        </div>
      </Modal>
      {/* Reply Modal */}
      <Modal
        className="modal fade"
        id="replyModal"
        show={state.reply}
        onHide={() => dispatch({ type: "replyModal" })}
        centered>
        <div className="modal-header">
          <h5 className="modal-title">Post Reply</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => dispatch({ type: "replyModal" })}
          ></button>
        </div>
        <div className="modal-body">
          <form>
            <textarea
              className="form-control"
              rows="4"
              defaultValue={"Message"}
            />
          </form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger light">
            Close
          </button>
          <button type="button" className="btn btn-primary">
            Reply
          </button>
        </div>
      </Modal>
    </>
  );
}

export default UserProfile;
